import { SourceBasedExpression } from '../Expression.js';
export class AsSetExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource()
            .evaluate(visitor, localVariables);
        if (source instanceof Array) {
            return Array.from(new Set(source));
        }
    }
}
//# sourceMappingURL=AsSetExpression.js.map